var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"data"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }